import { addItem, getItems } from './db';

let PaymentConditionsTable = 'PaymentConditions';

export async function savePaymentConditions(data) {
    for await (const element of data) {
        await addItem(PaymentConditionsTable, element, '_id');
    }
}

export async function getLocalPaymentConditions() {
    return await getItems(PaymentConditionsTable);
}